import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import RachelSparkIcon from '../RachelSparkIcon/RachelSparkIcon';
import { getShimmerTextSx } from '../shimmerText';

const RachelCompactingCard = () => {
  const { translate } = useTranslation();

  return (
    <Stack direction="row" gap={1.25} alignItems="center">
      <RachelSparkIcon size={20} isPulsing />
      <Typography
        variant="body2"
        sx={(theme) => getShimmerTextSx(theme, { start: 50, middle: 70, end: 90 })}
      >
        {translate(LangEnum.RACHEL_COMPACTING)}
      </Typography>
    </Stack>
  );
};

export default RachelCompactingCard;
